import { createStyles, makeStyles, Theme } from '@material-ui/core';


const useStyles = makeStyles(({ colors }: Theme) => createStyles({
  selectWrapper: {
    maxWidth: 410,
    width: '100%',
  },
  select: {
    marginTop: 16,
    marginBottom: 25,
    border: `solid 1px ${colors.border}`,
    borderRadius: 4,
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  selectInput: {
    display: 'flex',
    height: 24,
    paddingLeft: 8,
    alignItems: 'center',
  },
  icon: {
    left: 0,
    position: 'absolute',
    height: 8,
    width: 8,
    borderRadius: '50%',
    background: 'black',
  },

  label: {
    color: '#515B6A',
    padding: 0,
    fontSize: '1rem',
  },
  title: {
    marginLeft: 16,
  },
}), { name: 'StatusSelect' });

export default useStyles;
